// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/towing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/towing/towing.js';

mount([g0]);
